import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MonthlyBusinessByDsaCard from "../MonthlyBusiness/monthlyBusinessDsa";
export default function MonthlyBusinessByDsa() {
  return (
    <DashboardLayout>
      <MonthlyBusinessByDsaCard />
    </DashboardLayout>
  );
}
